import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const fetchSlots = (date) =>
    api.get(`/booking/slots`, { params: { date } }).then((r) => r.data);

export const initPayment = (payload) =>
    api.post(`/booking/payment/init`, payload).then((r) => r.data);

export const verifyPayment = (payload) =>
    api.post(`/booking/payment/verify`, payload).then((r) => r.data);

export const finalizeBooking = (payload) =>
    api.post(`/booking/finalize`, payload).then((r) => r.data);

export const submitContact = (payload) =>
    api.post(`/contact`, payload).then((r) => r.data);

// ----- 2-Day Business Growth Workshop (₹50,000) -----
export const submitWorkshopEnquiry = (payload) =>
    api.post(`/workshop/enquiry`, payload).then((r) => r.data);

export const initWorkshopPayment = (payload) =>
    api.post(`/workshop/payment/init`, payload).then((r) => r.data);

export const verifyWorkshopPayment = (payload) =>
    api.post(`/workshop/payment/verify`, payload).then((r) => r.data);

// ----- Public blogs (auto-published + admin) -----
export const fetchConsultSettings = () =>
    api.get(`/consultation/settings`).then((r) => r.data);

export const fetchWorkshops = () =>
    api.get(`/workshops/public`).then((r) => r.data);

export const fetchWorkshop = (slug) =>
    api.get(`/workshops/public/${slug}`).then((r) => r.data);

export const initWorkshopSeat = (slug, payload) =>
    api.post(`/workshops/${slug}/payment/init`, payload).then((r) => r.data);

export const verifyWorkshopSeat = (payload) =>
    api.post(`/workshops/payment/verify`, payload).then((r) => r.data);

// ----- Digital Downloads -----
export const fetchDownloads = () =>
    api.get(`/downloads/public`).then((r) => r.data);

export const fetchDownload = (slug) =>
    api.get(`/downloads/public/${slug}`).then((r) => r.data);

export const claimFreeDownload = (slug, payload) =>
    api.post(`/downloads/${slug}/free`, payload).then((r) => r.data);

export const initDownloadPayment = (slug, payload) =>
    api.post(`/downloads/${slug}/payment/init`, payload).then((r) => r.data);

export const verifyDownloadPayment = (payload) =>
    api.post(`/downloads/payment/verify`, payload).then((r) => r.data);

export const retrieveDownloads = (payload) =>
    api.post(`/downloads/retrieve`, payload).then((r) => r.data);

// ----- Shop (physical products, direct Buy Now) -----
export const fetchShopProducts = () =>
    api.get(`/shop/public`).then((r) => r.data);

export const fetchShopProduct = (slug) =>
    api.get(`/shop/public/${slug}`).then((r) => r.data);

export const initShopPayment = (slug, payload) =>
    api.post(`/shop/${slug}/payment/init`, payload).then((r) => r.data);

export const verifyShopPayment = (payload) =>
    api.post(`/shop/payment/verify`, payload).then((r) => r.data);

export const fetchPublicBlogs = () =>
    api.get(`/blogs/public`).then((r) => r.data);

export const fetchPublicBlog = (slug) =>
    api.get(`/blogs/public/${slug}`).then((r) => r.data);

// ----- Business Diagnostic Report (₹999) -----
export const initDiagnostic = (payload) =>
    api.post(`/diagnostic/payment/init`, payload).then((r) => r.data);

export const verifyDiagnostic = (payload) =>
    api.post(`/diagnostic/payment/verify`, payload).then((r) => r.data);

export const validateCoupon = (code, plan, email) =>
    api.post(`/coupon/validate`, { code, plan, email }).then((r) => r.data);

export const uploadDiagnosticFile = (id, formData) =>
    api
        .post(`/diagnostic/${id}/upload`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        })
        .then((r) => r.data);

export const UPLOAD_CATEGORY_LABELS = {
    logo: "Logo files",
    profile: "Company profile / brochure",
    products: "Product / service images",
    location: "Store / office / location",
    marketing: "Marketing screenshots",
    other: "Other",
};

export const submitDiagnostic = (payload) =>
    api.post(`/diagnostic/submit`, payload).then((r) => r.data);

export const getDiagnosticStatus = (id) =>
    api.get(`/diagnostic/${id}/status`).then((r) => r.data);

// ----- Admin -----
export const adminLogin = (payload) =>
    api.post(`/auth/login`, payload).then((r) => r.data);

export const adminMe = (token) =>
    api.get(`/auth/me`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminGet = (path, token) =>
    api.get(path, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminPost = (path, token) =>
    api.post(path, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminPostBody = (path, body, token) =>
    api.post(path, body || {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminPatch = (path, body, token) =>
    api.patch(path, body || {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminDelete = (path, token) =>
    api.delete(path, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminCreateManual = (payload, token) =>
    api.post(`/admin/diagnostics/manual`, payload, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminSendReport = (id, token) =>
    api.post(`/admin/diagnostics/${id}/send-report`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

// Safely extract a user-friendly message; ignore non-JSON bodies (e.g. Cloudflare HTML 502).
export const apiErr = (e, fallback) => {
    const d = e?.response?.data;
    return d && typeof d === "object" && d.detail ? d.detail : fallback;
};
